<!-- ======= New Sidebar Footer (Start) ======= -->
@if (loginService.newSidebar) {
  <div class="as-nav__user-divider"></div>

  <div
    class="as-nav__user"
    [class.as-nav__user--open]="userMenuOpen"
    role="button"
    tabindex="0"
    (click)="toggleUserMenu()"
    (keyup.enter)="toggleUserMenu()"
    (keyup.space)="toggleUserMenu()"
  >
    <div class="as-nav__user-avatar">
      <span>{{ userInitials }}</span>
    </div>
    <div class="as-nav__user-info">
      <div class="as-nav__user-name">{{ displayName }}</div>
      <div class="as-nav__user-handle">{{ loginService.Clinic }}</div>
    </div>
    <mat-icon class="as-nav__chevron" [class.as-nav__chevron--open]="userMenuOpen"
      >expand_more</mat-icon
    >
  </div>

  @if (userMenuOpen) {
    <div class="as-nav__submenu">
      <a class="as-nav__submenu-item" (click)="goDefaults()" routerLink="/defaults">
        {{ 'GUI.General.Buttons.Defaults' | translate | titlecase }}
      </a>
      @if (loginService.premissions?.Stats) {
        <a class="as-nav__submenu-item" routerLink="/Stats">
          {{ 'GUI.General.Buttons.Stats' | translate | titlecase }}
        </a>
      }
      @if (loginService.premissions?.Questionnaires) {
        <a class="as-nav__submenu-item" (click)="redirectAdministration('questionnaires')">
          {{ 'GUI.General.Buttons.Questionnaires' | translate | titlecase }}
        </a>
      }
      @if (loginService.isAdmin && loginService.premissions?.Limits) {
        <a class="as-nav__submenu-item" (click)="showLimits = true"> Limits </a>
      }
      @if (loginService.ishospital && loginService.isAdmin) {
        <a class="as-nav__submenu-item" (click)="showLogin = true"> Export Data </a>
      }
      @if (loginService.premissions?.DataminingAI) {
        <a class="as-nav__submenu-item" routerLink="/datamine">Datamining AI helper</a>
      }
      @if (
        (loginService.ishospital && (loginService.isAdmin || loginService.premissions?.Stats)) ||
        (!loginService.ishospital && loginService.premissions?.searchText)
      ) {
        <a class="as-nav__submenu-item" routerLink="/Searchdata">
          {{ 'GUI.General.Buttons.Search by Text' | translate | titlecase }}
        </a>
      }
      <a class="as-nav__submenu-item as-nav__submenu-item--teal" (click)="showAbout = true">
        {{ 'GUI.General.Buttons.About' | translate | titlecase }}
      </a>
      <div class="as-nav__divider"></div>

      <button class="as-nav__logout" (click)="logout()">
        <mat-icon class="as-nav__logout-icon">logout</mat-icon>
        <span>{{ 'GUI.General.Logout' | translate | titlecase }}</span>
      </button>
    </div>
  }
}
<!-- ======= New Sidebar Footer (End) ======= -->

<!-- ======= Legacy Sidebar Footer (Start) ======= -->
@if (!loginService.newSidebar) {
  <div class="drPanel">
    <i class="drPanel-icon icon-dr"></i>

    <div class="drPanel-info">
      <figure class="drPanel-image">
        <img src="assets/images/dr.jpg" alt="" />
      </figure>
      <div class="drPanel-desc">
        <div class="drPanel-name">
          {{ loginService.getUserName() }}
        </div>
        <div class="drPanel-detail">
          {{ loginService.Clinic }}
        </div>
      </div>
    </div>

    <div class="drPanel-controls">
      <a class="drPanel-controls-item drPanel-controls-icon-gear" [matMenuTriggerFor]="menu">
        {{ 'GUI.General.Settings' | translate | titlecase }}
      </a>
      <mat-menu #menu="matMenu">
        @if (loginService.premissions?.Dashboard) {
          <a mat-menu-item routerLink="/dashboard">
            {{ 'GUI.dashboard.labels.dashboard' | translate | titlecase }}
          </a>
        }
        <a mat-menu-item (click)="goDefaults()" routerLink="/defaults">
          {{ 'GUI.General.Buttons.Defaults' | translate | titlecase }}
        </a>
        @if (loginService.premissions?.Stats) {
          <a mat-menu-item routerLink="/Stats">
            {{ 'GUI.General.Buttons.Stats' | translate | titlecase }}
          </a>
        }
        @if (loginService.premissions?.Questionnaires) {
          <a mat-menu-item (click)="redirectAdministration('questionnaires')">
            {{ 'GUI.General.Buttons.Questionnaires' | translate | titlecase }}
          </a>
        }
        @if (loginService.isAdmin && loginService.premissions?.Limits) {
          <a mat-menu-item (click)="showLimits = true">Limits</a>
        }
        @if (loginService.ishospital && loginService.isAdmin) {
          <a mat-menu-item (click)="showLogin = true">Export Data</a>
        }
        @if (loginService.premissions?.DataminingAI) {
          <a mat-menu-item routerLink="/datamine">Datamining AI helper</a>
        }
        @if (
          (loginService.ishospital && (loginService.isAdmin || loginService.premissions?.Stats)) ||
          (!loginService.ishospital && loginService.premissions?.searchText)
        ) {
          <a mat-menu-item routerLink="/Searchdata">
            {{ 'GUI.General.Buttons.Search by Text' | translate | titlecase }}
          </a>
        }
        <a mat-menu-item (click)="showAbout = true">
          {{ 'GUI.General.Buttons.About' | translate | titlecase }}
        </a>
      </mat-menu>
      <a class="drPanel-controls-item drPanel-controls-icon-logout" (click)="logout()">
        {{ 'GUI.General.Logout' | translate | titlecase }}
      </a>
    </div>
  </div>
}
<!-- ======= Legacy Sidebar Footer (End) ======= -->

<!-- ======= Shared Popups (Start) ======= -->
@if (showLogin) {
  <app-loginbox (closed)="showLogin = false" [isExport]="true"></app-loginbox>
}
@if (showLimits) {
  <app-limits (closed)="showLimits = false"></app-limits>
}

@if (showAbout) {
  <div class="t-popup popup-patientDetails popup-patientDetails--about">
    <div class="t-popup-close"></div>
    <div class="t-popup-frame">
      <div class="t-popup-body">
        Artisan Sonics Ltd. Aweb application version: {{ currentApplicationVersion }}<br />
        Released: {{ currentAppDate }}<br />
        Using API version: {{ loginService.APIversion }}
        <br />
        <br />
        <a class="search-btn" target="_blank" href="../../assets/CHANGELOG.md">View Changelog</a>
        <button
          class="t-btn-popup-close"
          aria-label="close popup"
          (click)="showAbout = false"
        ></button>
      </div>
    </div>
  </div>
}
<!-- ======= Shared Popups (End) ======= -->
